/**
 * Integration of the glide js
 *
 * @slider
 */

// Import Slider
import Glide from '@glidejs/glide';

class slider{

    constructor(){
        let self = this;
        self.init();
    }

    init() {

        // trigger slider
        if ($('.c-slider').length === 0) return;

        $('.c-slider').each(function(index,item) {

            // Slider config
            let options = {
                'type' : 'carousel',
                'startAt' : 0,
                'perView' : 1,
                'focusAt' : 'center',
                'peek' : 200,
                'breakpoints' : {
                    800: {
                    peek: 0
                    },
                    1024: {
                        peek: 100
                    }
                }
            };

            let glide = new Glide(item, options);

            glide.mount();
        });

    }


}



export default new slider();